import { api } from "@/lib/api";

// Public reads
export const fetchChefs = (type) => api.get("/chefs", { params: type ? { type } : {} }).then((r) => r.data);
export const fetchChef = (id) => api.get(`/chefs/${id}`).then((r) => r.data);
export const fetchDishes = (params = {}) => api.get("/dishes", { params }).then((r) => r.data);
export const fetchBlog = () => api.get("/blog").then((r) => r.data);
export const fetchBlogPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
export const fetchAnnouncements = () => api.get("/announcements/active").then((r) => r.data);
export const fetchPage = (slug) => api.get(`/pages/${slug}`).then((r) => r.data);
export const createOrder = (payload) => api.post("/orders", payload).then((r) => r.data);
export const fetchSiteConfig = () => api.get("/site-config").then((r) => r.data);
export const fetchCategories = () => api.get("/categories").then((r) => r.data);
export const fetchI18n = (lang) => api.get(`/i18n/${lang}`).then((r) => r.data);
export const reportStrings = (strings) => api.post("/i18n/report", { strings });
export const changePassword = (payload) => api.post("/auth/change-password", payload).then((r) => r.data);

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// Resolve stored image paths (relative /api/files/...) to absolute URLs
export const resolveImg = (url) => (url && url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url);

export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

// Admin
export const adminOverview = () => api.get("/admin/overview").then((r) => r.data);
export const adminOrders = () => api.get("/admin/orders").then((r) => r.data);
export const adminAnnouncements = () => api.get("/admin/announcements").then((r) => r.data);
export const adminPages = () => api.get("/admin/pages").then((r) => r.data);
export const savePage = (slug, payload) => api.put(`/admin/pages/${slug}`, payload).then((r) => r.data);

export const crud = (base) => ({
  create: (payload) => api.post(`/admin/${base}`, payload).then((r) => r.data),
  update: (id, payload) => api.put(`/admin/${base}/${id}`, payload).then((r) => r.data),
  remove: (id) => api.delete(`/admin/${base}/${id}`).then((r) => r.data),
});

export const getSettings = (key) => api.get(`/admin/settings/${key}`).then((r) => r.data);
export const saveSettings = (key, payload) => api.put(`/admin/settings/${key}`, payload).then((r) => r.data);
export const adminCategories = () => api.get("/admin/categories").then((r) => r.data);
export const adminRoles = () => api.get("/admin/roles").then((r) => r.data);
export const adminUsers = () => api.get("/admin/users").then((r) => r.data);
export const setUserPassword = (id, password) => api.post(`/admin/users/${id}/password`, { password }).then((r) => r.data);
export const auditLogs = (q = "") => api.get("/admin/audit-logs", { params: { q, limit: 300 } }).then((r) => r.data);
export const listBackups = () => api.get("/admin/backups").then((r) => r.data);
export const createBackup = () => api.post("/admin/backups").then((r) => r.data);
export const adminTranslations = () => api.get("/admin/translations").then((r) => r.data);
export const autoTranslate = () => api.post("/admin/translations/auto").then((r) => r.data);

export const downloadFile = async (url, params = {}) => {
  const res = await api.get(url, { params, responseType: "blob" });
  const name = (res.headers["content-disposition"] || "").match(/filename="(.+)"/)?.[1] || "download";
  const link = document.createElement("a");
  link.href = URL.createObjectURL(res.data);
  link.download = name;
  link.click();
  URL.revokeObjectURL(link.href);
};
